





























































































import Vue, { PropType } from 'vue';
import ResponsePagingInfo from '../../plugins/servicelayer/responseTypes/responsePagingInfo';
import _ from '../../utils';
import IpTableColumn from '../p-table/IpTableColumn';

export default Vue.extend({
  props: {
    value: { type: [Object, Array], default: () => undefined },
    serviceFunction: { type: Function, default: undefined },
    columns: { type: Array as PropType<IpTableColumn[] | undefined>, default: undefined },
    canSelect: { type: Boolean, default: false },
    multiSelect: { type: Boolean, default: false },
    canSort: { type: Boolean, default: false },
    noPaging: { type: Boolean, default: false },
    pagination: { type: Object, default: () => ({}) },
    keyField: { type: String, default: 'id' },
  },
  data: () => ({
    innerPagination: {},
    requestError: undefined as any,
    selectedEntries: [],
    internalLoading: false,
  }),
  computed: {
    hasSlotTableActions() : boolean {
      return _.component.hasSlot(this, 'table-actions');
    },
    computedColumns() : any[] | undefined {
      if (!this.columns) {
        return undefined;
      }
      const computed = [...this.columns];
      if (_.component.hasSlot(this, 'entry-actions')) {
        computed.push({ value: '', field: 'entry-actions', textAlign: 'right' });
      }
      return computed;
    },
    items: {
      get() : any[] {
        const items = this.getItemsFromResponse(this.value);
        const computedItems = items.map((item: any) => {
          if (typeof item.toDTO === 'function') {
            item = item.toDTO();
          }
          // Don't spread item (non-enumerables get lost)
          item['entry-actions'] = { value: {} };
          return item;
        });
        return computedItems;
      },
      set(value: any) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    pagination: {
      immediate: true,
      deep: true,
      handler() {
        this.innerPagination = this.pagination;
      },
    },
  },
  mounted() {
    if (typeof this.serviceFunction === 'function') {
      this.populateList();
    }
  },
  methods: {
    getItemsFromResponse(value: any) {
      let items = value?.data?.result?.items as any[];
      if (!items) {
        items = value?.items;
      }
      if (!items) {
        if (Array.isArray(value)) {
          items = value;
        }
      }
      return items ?? [];
    },
    async onPaginationInput() {
      this.$debounce(async () => {
        this.$emit('update:pagination', this.innerPagination);
        await this.populateList();
      }, 500, this)();
    },
    async populateList() {
      if (!this.serviceFunction) {
        return;
      }
      const currPagination = this.innerPagination as ResponsePagingInfo;
      // TODO: Make defaults configurable
      const params = {
        query: {
          'paging.PageSize': currPagination?.pageSize ?? 10,
          'paging.CurrentPage': currPagination?.currentPage ?? 1,
          'paging.IncludeCount': true,
        },
      };
      this.internalLoading = true;
      try {
        const serviceResponse = await this.serviceFunction(params);

        const items = this.getItemsFromResponse(serviceResponse);
        // Legacy services returned a data object instead of the result
        this.innerPagination = serviceResponse?.data?.result?.pagination ?? serviceResponse?.data?.result?.paginationData;
        if (!this.innerPagination) {
          this.innerPagination = serviceResponse?.pagination ?? serviceResponse?.paginationData;
        }
        this.$emit('input', items);
      } catch (error) {
        this.$log.error(error);
        this.requestError = error;
      }
      this.internalLoading = false;
    },
    onSort(...args: any[]) {
      this.$emit('header-cell-click', ...args);
      this.$emit('on-sort', ...args);
    },
    onSelectionChange(selection: any) {
      this.selectedEntries = selection;
      this.$emit('selection-change', selection);
    },
  },
});
